import { NextSeo } from "next-seo";
import faqs from "copy/leader_faqs.json";
import Navbar from "components/Navbar";
import LearnMore from "components/LearnMore";
import Footer from "components/Footer";
import content from "copy/for-leaders-page-content-en.json";
import learn_more_content from "copy/learn_more_content.json";
import {
  LeadershipHero,
  Opportunity,
  JoinANetwork,
  Enhance,
  InterviewProcess,
  ImmediateImpact,
  LearnFrom,
} from "components/leadership/sections";

const ForLeaders = () => {
  return (
    <>
      <NextSeo
        title="Become a Teamshares President - Teamshares"
        description="Become a CEO and lead a successful, employee-owned business into its next phase of growth as president."
        openGraph={{
          title: "Become a Teamshares President - Teamshares",
          description:
            "Become a CEO and lead a successful, employee-owned business into its next phase of growth as president.",
          images: [
            {
              url: "/teamshares-social-banner.png",
              alt: "Teamshares Social Banner",
            },
          ],
        }}
      />
      <div className="page min-h-screen antialiased leading-normal">
        <main className="page-content page-leadership">
          <div className="Navbar__sticky-wrapper">
            <Navbar is_dark={true} current_page={"for-leaders"} />
          </div>
          <LeadershipHero {...content.leadershipHero} />
          <Opportunity {...content.opportunity} />
          <JoinANetwork {...content.joinANetwork} />
          <Enhance {...content.enhance} />
          <InterviewProcess {...content.interviewProcess} />
          <ImmediateImpact {...content.immediateImpact} />
          <LearnFrom {...content.learnFrom} />
          <LearnMore
            block1={{ ...learn_more_content.home }}
            block2={{ ...learn_more_content.brokers }}
          />
          <Footer />
        </main>
      </div>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NSHRHMS" height="0" width="0" style="display: none; visibility: hidden;" />`,
        }}
      />
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {
      faqData: faqs,
    },
  };
}

export default ForLeaders;
